import { render, staticRenderFns } from "./SkindexChampionCard.vue?vue&type=template&id=6168cf71&scoped=true&"
import script from "./SkindexChampionCard.vue?vue&type=script&lang=js&"
export * from "./SkindexChampionCard.vue?vue&type=script&lang=js&"
import style0 from "./SkindexChampionCard.vue?vue&type=style&index=0&id=6168cf71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6168cf71",
  null
  
)

export default component.exports